import { useLoaderStore } from '~/store/loader'

export default defineNuxtRouteMiddleware((to, from) => {
  if (to.name !== from.name) {
    useLoaderStore().setLoader(false)
  }
})
